var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.fullscreen.lock",
          value: _vm.loading,
          expression: "loading",
          modifiers: { fullscreen: true, lock: true },
        },
      ],
      staticClass: "clearfix main_center",
    },
    [
      _c("div", { staticClass: "top-content busWinessLeft" }, [
        _c(
          "div",
          { staticClass: "left-navbar" },
          [
            _c(
              "el-button",
              {
                attrs: { size: "small" },
                on: {
                  click: function ($event) {
                    return _vm.back()
                  },
                },
              },
              [_vm._v("返回")]
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "right-content clearfix busWinessRight" },
        [
          _c(
            "el-card",
            { staticClass: "box-card", attrs: { shadow: "never" } },
            [
              _c(
                "div",
                { staticClass: "monitor-video" },
                [
                  _c(
                    "div",
                    { staticClass: "monitor-video-list" },
                    [
                      _c("videoPlayer", {
                        ref: "videoPlayerRef",
                        attrs: {
                          videoUrl: _vm.videoUrl,
                          videoCode: "mp4",
                          isShowControls: true,
                          keyIframeOffset: _vm.keyIframeOffset,
                          ifisShowControl: true,
                        },
                        on: {
                          "update:videoUrl": function ($event) {
                            _vm.videoUrl = $event
                          },
                          "update:video-url": function ($event) {
                            _vm.videoUrl = $event
                          },
                          "update:keyIframeOffset": function ($event) {
                            _vm.keyIframeOffset = $event
                          },
                          "update:key-iframe-offset": function ($event) {
                            _vm.keyIframeOffset = $event
                          },
                          switchCurrentVideo: _vm.switchVideoUrl,
                        },
                      }),
                    ],
                    1
                  ),
                  _c("placeAndEquipment", {
                    ref: "placeAndEquipmentRef",
                    attrs: {
                      roomType: _vm.openBidWitness_dataTypeObj.bidEvaluation,
                      abTop: "180px",
                      abRight: "62px",
                      currentVideo: _vm.currentVideo,
                      videoSwitchData: _vm.videoSrcData,
                    },
                    on: {
                      "update:currentVideo": function ($event) {
                        _vm.currentVideo = $event
                      },
                      "update:current-video": function ($event) {
                        _vm.currentVideo = $event
                      },
                      "update:videoSwitchData": function ($event) {
                        _vm.videoSrcData = $event
                      },
                      "update:video-switch-data": function ($event) {
                        _vm.videoSrcData = $event
                      },
                      switchCurrentVideo: _vm.switchVideoUrl,
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _c(
            "el-form",
            {
              ref: "form",
              staticClass: "form",
              staticStyle: { "margin-top": "12px", padding: "0px 24px" },
              attrs: { model: _vm.form, "label-width": "138px" },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 15 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "抽取颗粒度：", prop: "dataGroup" } },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.form.dataGroup == "1"
                                  ? "关联项目"
                                  : _vm.form.dataGroup == "2"
                                  ? "关联标段"
                                  : "标段组合"
                              )
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticStyle: {
                            width: "calc(100% - 100px)",
                            display: "inline-block",
                          },
                          attrs: {
                            label:
                              _vm.form.dataGroup == 1
                                ? "关联项目："
                                : _vm.form.dataGroup == "2"
                                ? "关联标段："
                                : "标段组合：",
                            prop: "releProjectName",
                          },
                        },
                        [
                          _vm.form.dataGroup == "1" || _vm.form.dataGroup == "2"
                            ? _c("span", [_vm._v(_vm._s(_vm.displayName))])
                            : _c(
                                "p",
                                _vm._l(
                                  _vm.form.bidList,
                                  function (item, index) {
                                    return _c(
                                      "el-tag",
                                      {
                                        key: index,
                                        attrs: { size: "small", type: "info" },
                                      },
                                      [_vm._v(_vm._s(item.bidSectionName))]
                                    )
                                  }
                                ),
                                1
                              ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "监督记录：", prop: "remark" } },
                        [
                          _c("el-input", {
                            attrs: { type: "textarea", disabled: "", rows: 3 },
                            model: {
                              value: _vm.form.remark,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "remark", $$v)
                              },
                              expression: "form.remark",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "监督人：", prop: "superviseMan" } },
                        [
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.form.superviseManName,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "superviseManName", $$v)
                              },
                              expression: "form.superviseManName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "记录关键帧：" } },
                        [
                          _c(
                            "el-table",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.keyListLoading,
                                  expression: "keyListLoading",
                                },
                              ],
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: _vm.tableDataDetail.slice(
                                  (_vm.pageIndex - 1) * _vm.pageSize,
                                  _vm.pageIndex * _vm.pageSize
                                ),
                                border: "",
                                stripe: "",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  "header-align": "center",
                                  label: "序号",
                                  width: "50",
                                  type: "index",
                                  align: "center",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  "header-align": "center",
                                  label: "操作",
                                  width: "80",
                                  align: "center",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "text",
                                              size: "small",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.confirmPosition(
                                                  scope.row.timeDeviationSec,
                                                  scope.$index
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("定位")]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "recordTime",
                                  "header-align": "center",
                                  label: "时间",
                                  width: "180",
                                  align: "center",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-left": "10px",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(scope.row.recordTimeStr)
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "快照",
                                  align: "center",
                                  width: "100",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function (scope) {
                                      return [
                                        scope.row.screenshotUrl
                                          ? _c("img", {
                                              staticClass: "thumbnail",
                                              attrs: {
                                                src: scope.row.screenshotUrl,
                                                alt: "",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.showImgDialog(
                                                    scope.row.screenshotUrl
                                                  )
                                                },
                                              },
                                            })
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "remark",
                                  "header-align": "center",
                                  "show-overflow-tooltip": true,
                                  label: "备注",
                                },
                              }),
                            ],
                            1
                          ),
                          _c("el-pagination", {
                            attrs: {
                              "hide-on-single-page": "",
                              "current-page": _vm.pageIndex,
                              "page-sizes": [10, 20, 50, 100],
                              "page-size": _vm.pageSize,
                              total: _vm.total,
                              layout: "total, sizes, prev, pager, next, jumper",
                            },
                            on: {
                              "size-change": _vm.sizeChangeHandle,
                              "current-change": _vm.currentChangeHandle,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "监督记录提交时间：" } },
                        [
                          _c("el-input", {
                            attrs: { disabled: "" },
                            model: {
                              value: _vm.form.updateTime,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "updateTime", $$v)
                              },
                              expression: "form.updateTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.imgDialogVisible,
            width: "100%",
            height: "100%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.imgDialogVisible = $event
            },
            closed: _vm.dialogClose,
          },
        },
        [
          _c("img", {
            staticClass: "viewImg",
            attrs: { src: _vm.dialogImageUrl, alt: "" },
            on: {
              contextmenu: function ($event) {
                $event.preventDefault()
              },
            },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }